import { formatMoney } from "@/utils/money-format.helper";
import useBreakpoint from "@/hooks/use-breakpoint";
import { useHandleGetOffer } from "./hooks/handleSubmitHook";
import { IconButton } from "@/Components/ui/icon-button";
import { Button } from "@/Components/ui/button";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/use-translation";

export type PriceComponentProps = {
   totalCurrentPrice: number;
   offer: boolean;
   goToNext: () => void;
   goToPrevious: () => void;
};

export default function PriceComponent({
   totalCurrentPrice,
   offer,
   goToNext,
   goToPrevious,
}: PriceComponentProps) {
   const { isMobile } = useBreakpoint();
   const { handleGetOffer } = useHandleGetOffer();
   const { translation } = useTranslation();
   const actionLabel = offer
      ? translation.configurator.getOffer
      : translation.configurator.next;
   const onAction = offer ? handleGetOffer : goToNext;

   return (
      <div className="bg-white border-t border-t-custom-grey">
         <div
            className={cn(
               "flex justify-between items-center",
               isMobile ? "px-4 py-3" : "px-6 py-4"
            )}
         >
            <span className="text-d-body-l-paragraph text-custom-black/60">
               {translation.configurator.priceVat}
            </span>
            <span className="text-d-body-l-paragraph text-custom-black">
               {formatMoney(totalCurrentPrice, { currency: "EUR" })}
            </span>
         </div>
         <div
            className={cn(
               "flex items-center",
               isMobile ? "px-4 pb-3 space-x-2" : "px-6 pb-6 space-x-2"
            )}
         >
            <IconButton variant="back" onClick={goToPrevious} />
            <Button className="flex-1" variant="l-white" onClick={onAction}>
               {actionLabel}
            </Button>
         </div>
      </div>
   );
}
